<div class="modal inmodal fade in parcel-modal create-edit-parcel-modal parcel-transit-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title">{{keyLogService.signOutKeyModal ? 'Sign Key Out' : 'Return Key'}}</h4>
                </div>
                <div class="modal-body">
                    <!-- ___ Key Tag ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Key Tag</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{data.keyTag}}
                        </div>
                    </div>

                    <!-- ___ Unit ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Unit</label>
                        </div>
                        <div class="col-md-8 fourteenPixelText">
                            {{data.suiteNumber}}
                        </div>
                    </div>

                    <!-- ___ Returned By/Issued To___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>{{keyLogService.returnKeyModal ? 'Returned By' : 'Issued To'}}</label>
                        </div>
                        <div class="col-md-8">
                            <input class="form-control" name="user" [ngModel]="data.user" required>
                        </div>
                    </div>

                    <!-- ___ Release/Issue Notes  ___ -->
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>{{keyLogService.signOutKeyModal ? 'Release' : 'Issue'}} Notes</label>
                        </div>
                        <div class="col-md-8">
                            <textarea class="form-control"
                                      name="activityNotes" [ngModel]="data.activityNotes" maxlength="255"></textarea>
                        </div>
                    </div>

                    <div *ngIf="keyLogService.corporationSettings && keyLogService.corporationSettings.useSignaturePadStatus">
                        <div class="row m-t-md m-b-md">
                            <div class="col-sm-4">
                                <div class="input-radio">
                                    <input id="with-sign" type="radio" class="i-checks" name="sign" ngModel [value]="1">
                                    <label for="with-sign">Signature</label>
                                </div>
                            </div>
                            <div class="col-sm-8" *ngIf="form.value.sign == 1">
                                <signature-field name="signBase" [ngModel]="data.signBase"></signature-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-8">
                                <div class="input-radio">
                                    <input id="without-sign" type="radio" class="i-checks"
                                           name="sign"  [ngModel]="0" [value]="0">
                                    <label for="without-sign">Save Without Signature</label>
                                </div>
                            </div>
                            <div class="col-sm-4"></div>
                        </div>
                    </div>

                    <div class="row text-center space-30">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/key-log/signOutReturnKeyModal/sign-out-return-key-modal.component.html